import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import PhotoUploader from "../../components/PhotoUploader";

export default function CoffeePhotos({
  photos = [],
  onChange,
  onProcessingChange,
  processing = false,
  maxPhotos = 10,
  readOnly = false,
}) {
  const [preview, setPreview] = useState(null);
  const limit = Math.min(10, Math.max(1, maxPhotos));
  const add = (image) => {
    if (image && photos.length < limit) onChange([...photos, image]);
  };
  return (
    <div>
      {!readOnly && (
        <>
          <PhotoUploader
            value=""
            onChange={add}
            onProcessingChange={onProcessingChange}
            disabled={processing || photos.length >= limit}
            maxUploadBytes={500 * 1024}
            maxDimension={1280}
            forceJpeg
            helperText={`Opcionales. Hasta ${limit} imágenes por registro. Máximo 500 KB por imagen después de comprimir.`}
          />
          {processing && <p role="status">Preparando imagen…</p>}
          {photos.length >= limit && (
            <p role="status">Se alcanzó el máximo de {limit} imágenes.</p>
          )}
        </>
      )}
      {photos.length > 0 && (
        <>
          <p className="coffee-hint">
            {photos.length}{" "}
            {photos.length === 1 ? "imagen adjunta" : "imágenes adjuntas"}
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
              gap: "12px",
            }}
          >
            {photos.map((image, index) => (
              <div key={index}>
                <button
                  type="button"
                  aria-label={`Ampliar imagen ${index + 1}`}
                  disabled={processing}
                  onClick={() => setPreview(image)}
                  style={{ padding: 0, width: "100%" }}
                >
                  <img
                    src={image}
                    alt={`Imagen adjunta ${index + 1}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "120px",
                      objectFit: "contain",
                    }}
                  />
                </button>
                {!readOnly && (
                  <button
                    type="button"
                    aria-label={`Eliminar imagen ${index + 1}`}
                    disabled={processing}
                    onClick={() =>
                      onChange(photos.filter((_, at) => at !== index))
                    }
                  >
                    Eliminar
                  </button>
                )}
              </div>
            ))}
          </div>
        </>
      )}
      <Dialog
        header="Imagen del registro"
        visible={Boolean(preview)}
        onHide={() => setPreview(null)}
        modal
        style={{ width: "min(94vw, 980px)" }}
      >
        {preview && (
          <img
            src={preview}
            alt="Imagen del registro ampliada"
            style={{ width: "100%", maxHeight: "75vh", objectFit: "contain" }}
          />
        )}
      </Dialog>
    </div>
  );
}
